import React from 'react'

function DailyReport() {
  return (
    <div>DailyReport</div>
  )
}

export default DailyReport